import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wireStreamingEvents = (
  engine: TriggerEngine,
): EventSourceResult => {
  const onStarted = () => engine.fireEvent("stream_started");
  const onStopped = () => engine.fireEvent("stream_stopped");

  engine.Radio.Streaming.on("started", onStarted);
  engine.Radio.Streaming.on("stopped", onStopped);

  return {
    unsubscribers: [
      () => engine.Radio.Streaming.off("started", onStarted),
      () => engine.Radio.Streaming.off("stopped", onStopped),
    ],
  };
};
